// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum AlertWebhookFormat {
	Auto = 0,
	Generic = 1,
	Slack = 2,
	Teams = 3,
}

export const AlertWebhookFormatDisplayNames: { [key in keyof typeof AlertWebhookFormat]?: string} = {
	"Auto": "Auto",
	0 : "Auto",
	"Generic": "Generic",
	1 : "Generic",
	"Slack": "Slack",
	2 : "Slack",
	"Teams": "Teams",
	3 : "Teams",
}

export const getAlertWebhookFormatDisplayName = (key: AlertWebhookFormat | (keyof typeof AlertWebhookFormat & string)) => {
	return AlertWebhookFormatDisplayNames[key];
}

